import { render } from "./FlexMessageComponents.vue?vue&type=template&id=73bd9ad0&scoped=true"
import script from "./FlexMessageComponents.vue?vue&type=script&lang=ts"
export * from "./FlexMessageComponents.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-73bd9ad0"

export default script